import type { TOC } from "@ember/component/template-only";
import mergeClasses from "glesys-controlpanel/modifiers/merge-classes";
import type { DropdownItemSignature } from "./item";
import DropdownItem from "./item";

const DropdownDestructiveItem: TOC<DropdownItemSignature> = <template>
  <DropdownItem class="text-red-600 hover:text-red-800 hover:bg-red-100" {{mergeClasses}} ...attributes>
    {{yield}}
  </DropdownItem>
</template>;

export default DropdownDestructiveItem;
